import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TogetherDIPStage } from '../models/app.models';
import * as _ from 'lodash-es';
import { SubmissionRequestStatus } from 'app/models/enums';
/**
 * Service for manageing session state style information for the DIP Application
 *
 * @export
 * @class DipStateService
 */
@Injectable()
export class DipStateService {

    /**
     * Metadata for all Stages
     *
     * **TODO** This is a messy implementation and needs to be abstracted away somewhere
     *
     * @readonly
     * @type {object}
     * @memberof DipStateService
     */
    public get allStages(): object {
        return {
            tad_stage_info: new TogetherDIPStage({
                reference: 'tad_stage_info',
                page_title: 'Pre-approval in minutes',
                title: 'Pre-approval in minutes',
                sub_title: `We can pre-approve a short-term loan before, and even during an auction,
                 without affecting your credit file. It’s free, takes less than 5 minutes and we won’t
                 share your information with anyone.`,
                forward_reference: 'tad_stage_eligibility',
                heading_image: 'pre-approval',
                num: 100,
                stageDescription: 'DipStart',
            }),
            tad_stage_apply: new TogetherDIPStage({
                reference: 'tad_stage_apply',
                page_title: 'Apply for a loan',
                title: 'Apply for a loan',
                sub_title: `Complete a full application for a short-term loan
                    and get a decision, normally within one working day.`,
                forward_reference: 'tad_stage_eligibility',
                backward_reference: 'tad_stage_info',
                heading_image: 'apply-loan',
                num: 101,
                stageDescription: 'ApplicationStart',
            }),
            tad_stage_eligibility: new TogetherDIPStage({
                reference: 'tad_stage_eligibility',
                page_title: 'Check your eligibility',
                title: 'Check your eligibility',
                forward_reference: 'tad_stage_loan_details',
                backward_reference: 'tad_stage_apply',
                num: 102,
                stageDescription: 'CheckEligibility',
            }),
            tad_stage_loan_details: new TogetherDIPStage({
                reference: 'tad_stage_loan_details',
                page_title: 'Loan details',
                title: 'Loan details',
                forward_reference: 'tad_stage_applicant_details',
                backward_reference: 'tad_stage_eligibility',
                num: 103,
                currentStep: 1,
                stageDescription: 'LoanDetails',
            }),
            tad_stage_applicant_details: new TogetherDIPStage({
                reference: 'tad_stage_applicant_details',
                page_title: 'Applicant details',
                title: 'Applicant details',
                forward_reference: 'tad_stage_income_details',
                backward_reference: 'tad_stage_loan_details',
                num: 104,
                currentStep: 2,
                stageDescription: 'ApplicantsDetails',
            }),
            tad_stage_income_details: new TogetherDIPStage({
                reference: 'tad_stage_income_details',
                page_title: 'Income details',
                title: 'Income details',
                forward_reference: 'tad_stage_property_details',
                backward_reference: 'tad_stage_applicant_details',
                num: 105,
                currentStep: 3,
                stageDescription: 'IncomeDetails',
            }),
            tad_stage_property_details: new TogetherDIPStage({
                reference: 'tad_stage_property_details',
                page_title: 'Property details',
                title: 'Property details',
                forward_reference: 'tad_stage_dip_overview',
                backward_reference: 'tad_stage_income_details',
                num: 106,
                currentStep: 4,
                stageDescription: 'PropertyDetails',
            }),
            tad_stage_outcome: new TogetherDIPStage({
                reference: 'tad_stage_outcome',
                page_title: 'We\'re just checking a few things...',
                title: 'Your pre-approval',
                forward_reference: 'tad_stage_additional_loan_details',
                backward_reference: 'tad_stage_property_details',
                heading_image: 'great-news',
                stageDescription: 'DipOutcome',
            }),
            tad_stage_additional_loan_details: new TogetherDIPStage({
                reference: 'tad_stage_additional_loan_details',
                page_title: 'Additional loan details',
                title: 'Additional loan details',
                forward_reference: 'tad_stage_solicitors_details',
                backward_reference: 'tad_stage_property_details',
                num: 108,
                currentStep: 1,
                stageDescription: 'AdditionalDetails',
            }),
            tad_stage_solicitors_details: new TogetherDIPStage({
                reference: 'tad_stage_solicitors_details',
                page_title: 'Solicitor\'s details',
                title: 'Some final questions',
                forward_reference: 'tad_stage_application_overview',
                backward_reference: 'tad_stage_additional_loan_details',
                num: 109,
                currentStep: 2,
                stageDescription: 'SolicitorDetails',
            }),
            tad_stage_login: new TogetherDIPStage({
                reference: 'tad_stage_login',
                page_title: 'Retrieve your details',
                title: 'Retrieve your details',
                forward_reference: 'tad_stage_login_recap',
                stageDescription: 'RetrieveCase',
            }),
            tad_stage_login_recap: new TogetherDIPStage({
                reference: 'tad_stage_login_recap',
                page_title: 'Welcome back',
                title: 'Your Decision in Principle',
                forward_reference: 'tad_stage_edit',
                stageDescription: 'RetrievalRecap',
            }),
            tad_stage_edit: new TogetherDIPStage({
                reference: 'tad_stage_edit',
                page_title: 'Here\'s what you\'ve told us so far',
                title: 'Here\'s what you\'ve told us so far',
                forward_reference: 'tad_stage_additional_loan_details',
                stageDescription: 'EditCase',
            }),
            tad_stage_dip_overview: new TogetherDIPStage({
                reference: 'tad_stage_dip_overview',
                page_title: 'Here\'s what you\'ve told us so far',
                title: 'Here\'s what you\'ve told us so far',
                backward_reference: 'tad_stage_property_details',
                forward_reference: 'tad_stage_dip_submit',
                num: 107,
                stageDescription: 'DipSummary',
            }),
            tad_stage_dip_submit: new TogetherDIPStage({
                reference: 'tad_stage_dip_submit',
                page_title: 'We\'re processing your pre-approval',
                title: 'We\'re processing your pre-approval',
                forward_reference: 'tad_stage_outcome',
                heading_image: 'thank-you',
                num: 108,
                stageDescription: 'DipSubmitted',
            }),
            tad_stage_application_overview: new TogetherDIPStage({
                reference: 'tad_stage_application_overview',
                page_title: 'Here\'s what you\'ve told us so far',
                title: 'Here\'s what you\'ve told us so far',
                backward_reference: 'tad_stage_solicitors_details',
                forward_reference: 'tad_stage_application_submit',
                num: 110,
                stageDescription: 'ApplicationSummary',
            }),
            tad_stage_application_submit: new TogetherDIPStage({
                reference: 'tad_stage_application_submit',
                page_title: 'We\'re processing your application',
                title: 'We\'re processing your application',
                forward_reference: 'tad_stage_application_outcome',
                heading_image: 'thank-you',
                stageDescription: 'ApplicationSubmitted',
            }),
            tad_stage_application_outcome: new TogetherDIPStage({
                reference: 'tad_stage_application_outcome',
                page_title: 'Thank you',
                title: 'Thank you',
                heading_image: 'great-news',
                stageDescription: 'ThankYou',
            }),
        };
    }
    /**
     * The current stage that the process is up to
     *
     * @type {BehaviorSubject<TogetherDIPStage>}
     * @memberof DipStateService
     */
    public currentStage: BehaviorSubject<TogetherDIPStage>;
    /**
     * Is the journey DIP or not
     *
     * @type {BehaviorSubject<boolean>}
     * @memberof DipStateService
     */
    public isDipJourney: BehaviorSubject<boolean>;
    /**
     * What type of property are we dealing with
     * 0 - Residential
     * 1 - Commercial
     * 2 - Semi-commercial
     * 3 - Land
     * @type {BehaviorSubject<number>}
     * @memberof DipStateService
     */
    public propertyType: BehaviorSubject<number>;
    /**
     * The id for the created case (Guid)
     *
     * @type {BehaviorSubject<string>}
     * @memberof DipStateService
     */
    public caseId: BehaviorSubject<string>;
    /**
     * Getter for the current value of the caseId bahviour subject
     *
     * @readonly
     * @type {string}
     * @memberof DipStateService
     */
    get CaseId(): string {
        return this.caseId.getValue();
    }
    /**
     * Current page title
     *
     * @type {BehaviorSubject<string>}
     * @memberof DipStateService
     */
    public pageTitle: BehaviorSubject<string>;

    /**
    * Current page Summary
    *
    * @type {BehaviorSubject<string>}
    * @memberof DipStateService
    */
    public pageSummary: BehaviorSubject<string>;

    /**
     * Current page sub-title
     *
     * @type {BehaviorSubject<string>}
     * @memberof DipStateService
     */
    pageSubTitle: BehaviorSubject<string>;
    /**
     * Name of the sales person referring the case
     *
     * @private
     * @type {string}
     * @memberof DipStateService
     */
    private salesPerson: string;

    /**
     * Getter to get last value from BehaviorSubject.
     *
     * @readonly
     * @type {boolean}
     * @memberof DipStateService
     */
    get isDip(): boolean {
        return this.isDipJourney.getValue();
    }

    /**
     * salesPerson getter
     *
     * @type {string}
     * @memberof DipStateService
     */
    get SalesPerson(): string {
        return this.salesPerson;
    }
    /**
     * salesPerson setter
     *
     * @type {void}
     * @memberof DipStateService
     */
    set SalesPerson(val: string) {
        this.salesPerson = val;
    }
    /**
     * Sales reference for the referred case
     *
     * @private
     * @type {string}
     * @memberof DipStateService
     */
    private salesReference: string;
    /**
     * Sales reference getter
     *
     * @type {string}
     * @memberof DipStateService
     */
    get SalesReference(): string {
        return this.salesReference;
    }
    /**
     * Sales reference setter
     *
     * @type {void}
     * @memberof DipStateService
     */
    set SalesReference(val: string) {
        this.salesReference = val;
    }
    /**
     * The code for the dip decision
     *
     * @type {number}
     * @memberof DipStateService
     */
    dipOutcome: number;
    /**
     * Dip Outcome getter
     *
     * @type {number}
     * @memberof DipStateService
     */
    get DipOutcome(): number {
        return this.dipOutcome;
    }
    /**
     * Dip Outcome setter
     *
     * @memberof DipStateService
     */
    set DipOutcome(val: number) {
        this.dipOutcome = val;
    }
    /**
     * Is data loading
     *
     * @type {boolean}
     * @memberof DipStateService
     */
    isLoading: boolean = false;

    /**
     * Get isLoanding
     *
     * @type {boolean}
     * @memberof DipStateService
     */
    get IsLoading(): boolean {
        return this.isLoading;
    }
    /**
     * Set isLoading
     *
     * @memberof DipStateService
     */
    set IsLoading(val: boolean) {
        this.isLoading = val;
    }
    /**
     * Has the login process failed.
     *
     * @type {boolean}
     * @memberof DipStateService
     */
    loginFailed: boolean = false;

    /**
     * Is the DIP submitted?
     *
     * @type {SubmissionRequestStatus}
     * @memberof DipStateService
     */
    dipSubmissionStatus: SubmissionRequestStatus;

    /**
     * Is the application submitted?
     *
     * @type {SubmissionRequestStatus}
     * @memberof DipStateService
     */
    applicationSubmissionStatus: SubmissionRequestStatus;

    /**
     * Overrides the title of the page (<title>)
     * @param title
     */
    overridePageTitle(title: string): void {
        this.pageTitle.next(title);
    }

    /**
   * Overrides the title of the page (<title>)
   * @param title
   */
    overridePageSummary(title: string): void {
        this.pageSummary.next(title);
    }

    /**
     * Overrides the title of the page (<title>)
     * @param title
     */
    overridePageSubTitle(title: string): void {
        this.pageSubTitle.next(title);
    }

    /**
     * Resets the parameters for the state.
     *
     * @memberof DipStateService
     */
    reset() {
        this.caseId.next('00000000-0000-0000-0000-000000000000');
        this.isDipJourney.next(true);
        this.propertyType.next(0);
        this.salesPerson = null;
        this.salesReference = null;
    }

    /**
     * Creates an instance of DipStateService.
     * @param {Router} router
     * @memberof DipStateService
     */
    constructor(private router: Router) {
        this.caseId = new BehaviorSubject('00000000-0000-0000-0000-000000000000');
        this.pageTitle = new BehaviorSubject('');
        this.pageSummary = new BehaviorSubject('');
        this.pageSubTitle = new BehaviorSubject('');
        this.currentStage = new BehaviorSubject(new TogetherDIPStage());
        this.currentStage.subscribe((next) => {
            this.pageTitle.next(next.page_title);
            this.pageSubTitle.next(next.sub_title);
            this.pageSummary.next(next.summary);
        });
        this.isDipJourney = new BehaviorSubject(true);
        this.propertyType = new BehaviorSubject(0);
        this.dipSubmissionStatus = SubmissionRequestStatus.Uninitialised;
        this.applicationSubmissionStatus = SubmissionRequestStatus.Uninitialised;
        this.dipOutcome = 0;
    }

}
